import background_book_2x from 'app/assets/images/kings-birthday/background_book@2x.jpg'
import hero_donut from 'app/assets/images/kings-birthday/hero_donut.png'
import hero_donut_2x from 'app/assets/images/kings-birthday/hero_donut@2x.png'
import hero_donut_3x from 'app/assets/images/kings-birthday/hero_donut@3x.png'
import { media, style } from 'app/assets/styles'
import { Link } from 'app/common/link'
import { H4 } from 'app/common/typography'
import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Picture } from 'react-responsive-picture'
import { colors } from 'shared/assets/styles'
import { toSrcSet } from 'shared/utils'
import styled from 'styled-components'
import type { IntlShape } from 'react-intl'

const { red3, yellow } = colors

type Props = {
    intl: IntlShape
}

const BookPushCompoenent = (props: Props) => {
    const { intl } = props
    return (
        <BookPushContainer>
            <Push>
                <FormattedMessage id="king.birthday.book.title">
                    {(text: string) => <H4 color="white">{text}</H4>}
                </FormattedMessage>
                <FormattedMessage id="king.birthday.book.cta">
                    {(text: string) => (
                        <StyledButtonMedium
                            url={intl.formatMessage({
                                id: 'routes.birthday'
                            })}
                            background={red3}
                            color="white">
                            {text}
                        </StyledButtonMedium>
                    )}
                </FormattedMessage>
            </Push>
            <HeroDonut
                sources={[
                    {
                        srcSet: toSrcSet([
                            hero_donut,
                            hero_donut_2x,
                            hero_donut_3x
                        ])
                    }
                ]}
            />
        </BookPushContainer>
    )
}

const BookPushContainer = styled.div`
    position: relative;
    width: 100%;
    background-image: url(${background_book_2x});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    ${media.medium`
        padding: 0;
        min-height: 400px;
    `};
`

const Push = styled.div`
    text-align: center;
    background-color: ${yellow};
    padding: 15px;
    border-radius: 20px;
    margin: 0 20px;
    width: 100%;
    max-width: 500px;
    ${media.medium`
        max-width: 900px;
        padding: 50px;
    `};
`

const HeroDonut = styled(Picture)`
    display: none;
    font-size: 0;
    ${media.medium`
        display: block;
        position: absolute;
        z-index: 2;
        bottom: 0;
        top: unset;
        width: 150px;
        right: 0;
    `};
    ${media.large`
        width: 200px;
        right: calc((100% - 1280px) / 2 + 40px);
    `};
`

const StyledButtonMedium = styled(Link)`
    ${style.buttonMedium};
    border: none;
    margin-top: 20px;
`

const BookPush = injectIntl(BookPushCompoenent)

export { BookPush }
